import { Servicio } from "./types";

export const SERVICIOS: Servicio[] = [
  {
    slug: "asesoria-de-negocios",
    nombre: "Asesoría de negocios",
    frase: "Estructura y decisiones para tu empresa o emprendimiento.",
    intro:
      "Acompañamos a negocios en formación, operación y crecimiento: desde la constitución y los contratos hasta las decisiones diarias que implican responsabilidades legales.",
    paraQuien: [
      "Personas emprendiendo por primera vez",
      "Negocios en crecimiento sin asesor legal interno",
      "Socios que necesitan ordenar acuerdos",
      "Empresas que firman contratos con frecuencia",
    ],
    incluye: [
      "Constitución y documentación de la empresa",
      "Revisión y redacción de contratos",
      "Acuerdos entre socios y societario básico",
      "Políticas internas y cumplimiento esencial",
      "Acompañamiento en decisiones cotidianas",
    ],
    comoFunciona: [
      "Conocemos tu negocio y sus riesgos reales",
      "Priorizamos lo que protege la operación",
      "Documentamos las decisiones importantes",
      "Revisamos contigo el ritmo que tu negocio pida",
    ],
    momentosRelacionados: ["trabajo-y-negocio", "vivienda-y-patrimonio", "legado-y-sucesion"],
    seoTitle: "Asesoría de negocios",
    seoDesc:
      "Constitución, contratos, acuerdos entre socios y acompañamiento legal para negocios y emprendimientos.",
  },
  {
    slug: "bienes-y-patrimonio",
    nombre: "Bienes y patrimonio",
    frase: "Compra, venta y protección de lo que te ha costado construir.",
    intro:
      "Operamos y protegemos bienes: inmuebles, titularidades, contratos y planeación patrimonial básica. Revisión seria antes de firmar, y defensa firme cuando algo ya se torció.",
    paraQuien: [
      "Quienes van a comprar o vender un inmueble",
      "Familias con bienes mal titularizados o documentos viejos",
      "Quienes heredan o quieren dejar ordenado su legado",
      "Personas que detectan un posible fraude inmobiliario",
    ],
    incluye: [
      "Compra-venta y traslado de dominio de inmuebles",
      "Revisión de títulos y antecedentes registrales",
      "Contratos de compraventa, arras y depósito",
      "Regularización y prescripción",
      "Planeación patrimonial y testamentos",
    ],
    comoFunciona: [
      "Revisamos la documentación completa antes de cualquier firma",
      "Detectamos adeudos, antecedentes y riesgos reales",
      "Estructuramos la operación y la documentamos",
      "Damos seguimiento hasta el cierre y después",
    ],
    momentosRelacionados: ["vivienda-y-patrimonio", "legado-y-sucesion", "cambios-de-vida"],
    seoTitle: "Bienes y patrimonio",
    seoDesc:
      "Inmuebles, titularidad, regularización y planeación patrimonial con revisión seria de documentos.",
  },
  {
    slug: "familia-y-acuerdos",
    nombre: "Familia y acuerdos",
    frase: "Acuerdos que protegen a las personas y dan solución al conflicto pacíficamente.",
    intro:
      "Acompañamos decisiones familiares con una premisa: donde hay acuerdo posible, el acuerdo protege mejor que el litigio. Y cuando el proceso es inevitable, se hace con dignidad.",
    paraQuien: [
      "Parejas que quieren claridad antes o durante la convivencia",
      "Familias en proceso de separación o divorcio",
      "Madres, padres y tutores con temas de custodia o pensión",
      "Familias que ordenan cuidado, representación o herencias",
    ],
    incluye: [
      "Acuerdos y convenciones entre parejas",
      "Divorcio y separación, por acuerdo o vía judicial",
      "Custodia, convivencia y pensión alimenticia",
      "Reconocimientos y adopciones",
      "Sucesiones y testamentos",
    ],
    comoFunciona: [
      "Escuchamos la situación completa, sin juicios",
      "Identificamos lo que se puede resolver por acuerdo",
      "Formalizamos lo acordado para que se pueda sostener",
      "Representamos el proceso cuando el acuerdo no llega",
    ],
    momentosRelacionados: ["vida-en-pareja", "hijos-y-crianza", "cuidados-y-autonomia"],
    seoTitle: "Familia y acuerdos",
    seoDesc:
      "Divorcio, custodia, pensión y acuerdos familiares: acompañamiento con prioridad en el acuerdo.",
  },
  {
    slug: "defensa-laboral",
    nombre: "Defensa laboral",
    frase: "Para trabajadores y empleadores: derechos y obligaciones claros.",
    intro:
      "Defendemos derechos laborales de trabajadores y acompañamos a empleadores que quieren cumplir. Un problema laboral bien manejado a tiempo se resuelve mejor y más barato.",
    paraQuien: [
      "Trabajadores con despidos, adeudos o prestaciones pendientes",
      "Personas que les piden firmar renuncias o liquidaciones",
      "Empleadores que quieren contratos y prácticas correctas",
      "Negocios con conflicto laboral en curso",
    ],
    incluye: [
      "Despidos, renuncias y liquidaciones",
      "Adeudo de salarios, prestaciones y horas extraordinarias",
      "Contratos individuales y reglamentos de trabajo",
      "Conciliación y representación ante autoridades",
      "Prevención: prácticas y documentos en orden",
    ],
    comoFunciona: [
      "Revisamos tu evidencia: contratos, pagos, mensajes",
      "Calculamos lo que realmente te corresponde",
      "Intentamos la conciliación antes que el litigio",
      "Representamos el proceso con plazos realistas",
    ],
    momentosRelacionados: ["trabajo-y-negocio", "vida-independiente"],
    seoTitle: "Defensa laboral",
    seoDesc:
      "Despidos, liquidaciones, adeudos y contratos: defensa laboral para trabajadores y empleadores.",
  },
  {
    slug: "seguros-y-siniestros",
    nombre: "Seguros y siniestros",
    frase: "Cuando la póliza no fue suficiente cuando más la necesitabas.",
    intro:
      "Los seguros se entienden cuando pasa el siniestro, y ahí es donde más cuesta leer la letra pequeña. Revisamos pólizas, reclamamos indemnizaciones y contestamos negativas injustificadas.",
    paraQuien: [
      "Quienes tienen un siniestro y sienten que la aseguradora no responde",
      "Personas con pólizas que no entienden",
      "Quienes recibieron una negativa de reclamación",
      "Familias con seguros de vida, daños o gastos médicos",
    ],
    incluye: [
      "Revisión de pólizas antes de firmarlas",
      "Reclamación de siniestros",
      "Respuesta a negativas injustificadas",
      "Indemnizaciones y ajustes",
      "Acompañamiento en peritajes",
    ],
    comoFunciona: [
      "Leemos tu póliza y tu siniestro con criterio de cobertura real",
      "Integramos el expediente con la documentación correcta",
      "Reclamamos por la vía que más presión genere",
      "Litigiamos cuando la aseguradora no cumple",
    ],
    momentosRelacionados: ["vivienda-y-patrimonio", "cambios-de-vida"],
    seoTitle: "Seguros y siniestros",
    seoDesc:
      "Reclamación de siniestros, negativas injustificadas y revisión de pólizas con criterio de cobertura.",
  },
  {
    slug: "proteccion-del-consumidor",
    nombre: "Protección del consumidor",
    frase: "Cuando compras algo y lo que llega no es lo prometido.",
    intro:
      "Compras en línea, servicios que no llegan, garantías que nadie responde: el consumo diario genera derechos, y reclamarlos bien empieza con saber qué documentos tienes y quién responde.",
    paraQuien: [
      "Personas con compras o servicios fallidos",
      "Usuarios con cobros que no reconocen",
      "Quienes firman contratos de adhesión (gym, telefonía, seguros)",
      "Clientes con garantías que el proveedor ignora",
    ],
    incluye: [
      "Compras en línea y servicios no entregados",
      "Garantías y vicios ocultos",
      "Contratos de adhesión y cláusulas abusivas",
      "Reportes indebidos en buró de crédito",
      "Reclamaciones ante proveedores y autoridades",
    ],
    comoFunciona: [
      "Ordenamos tu evidencia: contratos, pagos, capturas",
      "Reclamamos primero directo al proveedor",
      "Escalamos a las autoridades que correspondan",
      "Litigiamos si el daño lo justifica",
    ],
    momentosRelacionados: ["vida-independiente", "trabajo-y-negocio"],
    seoTitle: "Protección del consumidor",
    seoDesc:
      "Compras fallidas, garantías, cobros indebidos y cláusulas abusivas: reclama con procedimiento claro.",
  },
  {
    slug: "proteccion-digital",
    nombre: "Protección digital",
    frase: "Tu vida en línea también tiene derechos.",
    intro:
      "Fraudes, suplantación, datos personales mal usados y contenido difundido sin consentimiento: el daño digital es real y tiene remedio legal cuando se atiende con rapidez y método.",
    paraQuien: [
      "Personas víctimas de fraude o suplantación en línea",
      "Quienes tienen sus datos personales mal usados",
      "Víctimas de acoso o difusión de contenido íntimo",
      "Usuarios atrapados en suscripciones o términos abusivos",
    ],
    incluye: [
      "Uso indebido de datos personales",
      "Fraudes y suplantación de identidad en línea",
      "Acoso y difusión de contenido sin consentimiento",
      "Términos de servicio y contratos digitales",
      "Cancelaciones y suscripciones abusivas",
    ],
    comoFunciona: [
      "Preservamos la evidencia antes de que desaparezca",
      "Ejercemos tus derechos ante plataformas y autoridades",
      "Reclamamos ante los responsables del uso de datos",
      "Acompañamos la reparación del daño",
    ],
    momentosRelacionados: ["vida-independiente", "hijos-y-crianza", "cambios-de-vida"],
    seoTitle: "Protección digital",
    seoDesc:
      "Fraudes en línea, suplantación, datos personales y acoso digital: protección legal con evidencia y método.",
  },
];

export const servicioBySlug = (slug?: string) => SERVICIOS.find((s) => s.slug === slug);
